<template>
  <div class="container" >
    <p class="title">已开通城市：</p>
    <DataTree :data="list" v-loading="loading" ></DataTree>
    <!-- <el-tree v-loading="loading" :data="list" :props="defaultProps"  class="tree_wrap" >
      <span class="custom-tree-node" slot-scope="{ data }">
        <span>{{ data.name }}-{{data.xianshi}} - {{data.id.length}}</span>
      </span>
    </el-tree> -->
  </div>
</template>

<script>
import DataTree from '../../components/dataTree'

export default {
  name: 'Company',
  components: {DataTree},
  data() {
    return {
      loading:false,
      list: [],
      defaultProps:{
        children: 'son',
        label: 'name'
      }
    }
  },

  created(){
    this.getCompanyList()
  },

  methods: {
    getCompanyList() {
      this.loading = true;
      this.$axios.get('/api/company/lists').then(res => {
        this.loading = false;
        console.log('data',res.data)
        this.list = res.data;
        // this.list = this.mapTree([],this.list)
        this.list = this.mapTree(this.list)
      });
    },

    mapTree(datalist) {
      datalist = datalist.filter(item=>{
        item.IsExpanded = false
        if(item.son && item.son.length > 0) {
          this.mapTree(item.son)
        }
        return item.xianshi !==0
      })
      return datalist
      // datalist.forEach(item1 => {   
      //   if (item1.xianshi === 1) {
      //     let json = {}
      //     let {id, pid, name, xianshi} = item1
      //     json.id = id
      //     json.pid = pid
      //     json.name = name
      //     json.xianshi = xianshi
      //     json.IsExpanded = false
      //     if (item1.son && item1.son.length >0){
      //       json.son = [] 
      //       this.mapTree(json.son,item1.son)
      //     }
      //     arr.push(json)
      //   }else{
      //     return
      //   }
      // })
      // console.log('mapTree', arr)
      // return arr
      
    },
    // mapTree(arr=[], datalist) {
    //   datalist.forEach(item1 => {   
    //     if (item1.xianshi === 1) {
    //       let json = {}
    //       let {id, pid, name, xianshi} = item1
    //       json.id = id
    //       json.pid = pid
    //       json.name = name
    //       json.xianshi = xianshi
    //       if (item1.son && item1.son.length >0){
    //         json.son = [] 
    //         item1.son.forEach(item2 => {
    //           if (item2.xianshi === 1) {
    //             let json2={}
    //             let {id, pid, name, xianshi} = item2
    //             json2.id = id
    //             json2.pid = pid
    //             json2.name = name
    //             json2.xianshi = xianshi
    //             if (item2.son && item2.son.length >0){
    //               json2.son = []
    //               item2.son.forEach(item3 => {
    //                 if (item3.xianshi === 1) {
    //                   let json3={}
    //                   if (item3.son && item3.son.length >0){
    //                     item3.son.forEach(item4 => {
    //                       console.log('一直在进行')
    //                     })
    //                   }
    //                   json2.son.push(item3)
    //                 }else{
    //                   return 
    //                 }
    //               })
    //             }
    //             json.son.push(json2)
                
    //           }else{
    //             return
    //           }
    //         })
    //       }
    //       arr.push(json)
    //     }else{
    //       return
    //     }
    //   })
    //   console.log('mapTree', arr)
    //   return arr
    // }
  }
};
</script>

<style lang="less">
.title{
  margin: 20px auto;
  font-size: 30px;
  color: #333;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/company/list.vue